export default __webpack_public_path__ + "static/media/fw-charlotte-er-Yellow Gold.325a1e71.mp4";